'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('./auth/index.js');
require('./users/index.js');
require('./roles/index.js');
require('./schema/index.js');
require('./secrets/index.js');
require('./privileges/index.js');
require('./queries/index.js');
require('./datasource/index.js');
require('./internal/index.js');
require('./system/index.js');
var request = require('./request.js');
require('./udt/index.js');
require('./groups/index.js');
require('./eco/index.js');
require('./s3/index.js');



exports.getAxiosInstance = request.getAxiosInstance;
